<template>
  <div
    class="relative flex flex-col"
  >
    <div
      class="flex"
      :class="{
        'h-[3em]': props.size === 'small',
        'h-[4em]': props.size === 'medium' || props.size === undefined,
      }"
    />
    <div
      class="absolute inset-0 bottom-auto flex flex-row justify-center"
      :class="{
        'h-[6em]': props.size === 'small',
        'h-[8em]': props.size === 'medium' || props.size === undefined,
      }"
    >
      <div
        class="flex aspect-square bg-primary rounded-xl overflow-hidden"
      >
        <font-awesome-icon
          v-if="props.icon"
          class="m-auto text-white"
          :class="{
            'text-[3em]': props.size === 'small',
            'text-[5em]': props.size === 'medium' || props.size === undefined,
          }"
          :icon="props.icon"
        />
        <NuxtPicture
          v-else-if="props.image"
          :src="props.image.src"
          :provider="props.provider"
          :modifiers="props.providerModifiers"
          :alt="props.image.alt || ''"
          :title="props.image.title"
          class="object-cover object-center w-full h-full"
        />
      </div>
    </div>
    <div
      class="rounded-md overflow-hidden shadow-lg border border-gray-200 bg-white"
    >
      <div
        class="flex-1 flex flex-col"
      >
        <div
          class="flex"
          :class="{
            'h-[3em]': props.size === 'small',
            'h-[4em]': props.size === 'medium' || props.size === undefined,
          }"
        />
        <div
          class="flex-1 flex flex-col gap-4 m-card"
        >
          <p
            class="text-center text-slate-900"
          >
            {{ props.text }}
          </p>
          <NuxtLink
            :to="props.to"
            :target="isExternal ? '_blank' : ''"
            class="text-center rounded py-2 px-4 w-full mx-auto mt-auto col-start-1 font-semibold"
            :class="{
              'bg-department text-department-contrast': props.department,
              'bg-primary text-white': !props.department,
            }"
          >
            <span>{{ props.label }}</span>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import type { Icon, Image } from '~/utils/types'

const props = defineProps<{
  // hovering icon/image
  icon?: Icon
  image?: Image
  provider?: string
  providerModifiers?: Record<string, any>
  // label of the button
  label: string
  // text in the card
  text: string
  // action on the button
  to?: RouteLocationRaw
  // size for the hover
  size?: 'small' | 'medium'
  department?: boolean
}>()

const isExternal = computed(() => typeof props.to == 'string' && props.to.startsWith('http'))
</script>

<style scoped lang="postcss">
:deep(img) {
  @apply object-cover object-center w-full h-full
}
</style>
